import { Switch } from "@heroui/react";
import { useEffect, useState } from "react";

import { PackagesPriceEntity } from "@/features/packages-price/type.ts";
import { useEditPackagesPrice } from "@/features/packages-price/use-packages-prices.ts";

export function TogglePackagesPricesStatus({
  packages,
}: {
  packages: PackagesPriceEntity;
}) {
  const [isSelected, setIsSelected] = useState(packages.isActive);
  const { mutateAsync } = useEditPackagesPrice();

  useEffect(() => {
    setIsSelected(packages.isActive);
  }, [packages.isActive]);

  return (
    <Switch
      isSelected={isSelected}
      onChange={(isActive) => {
        mutateAsync({ ...packages, isActive });
        setIsSelected(isActive);
      }}
    >
      <Switch.Control>
        <Switch.Thumb />
      </Switch.Control>
    </Switch>
  );
}
